import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vue2Editor from "vue2-editor";
import axios from 'axios';

//import firebase from "firebase/app";


import VirtualList from 'vue-virtual-scroll-list'

Vue.component('virtual-list', VirtualList)

Vue.use(Vue2Editor);

Vue.config.productionTip = false;
// set auth header
//axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;
const user = JSON.parse(localStorage.getItem('user'));
if(user){
axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;
axios.defaults.headers.common['Content-Type'] = 'application/json'
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");


/*
let app;
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      router,
      store,

      render: (h) => h(App),
    }).$mount("#app");
  }
});*/